/**
 * Status tones for badges, deltas and error marks. Status colours are reserved for status
 * (never a chart series), and always travel with an icon and a label.
 */
export type Tone = 'success' | 'warning' | 'danger' | 'info' | 'neutral';

/**
 * Icon and mark colour: the status token mixed 30% toward the text colour, which keeps every
 * tone at 3:1 or better against its tint in both themes (raw `--warning` is 1.8:1 on white).
 */
export const TONE_INK: Record<Tone, string> = {
  success: 'text-[color-mix(in_oklab,var(--success)_70%,var(--foreground))]',
  warning: 'text-[color-mix(in_oklab,var(--warning)_70%,var(--foreground))]',
  danger: 'text-[color-mix(in_oklab,var(--destructive)_70%,var(--foreground))]',
  info: 'text-[color-mix(in_oklab,var(--info)_70%,var(--foreground))]',
  neutral: 'text-muted-foreground',
};

/** Tinted surface behind a label in the normal text colour. */
export const TONE_SURFACE: Record<Tone, string> = {
  success: 'border-success/30 bg-success/10',
  warning: 'border-warning/40 bg-warning/15',
  danger: 'border-destructive/30 bg-destructive/10',
  info: 'border-info/30 bg-info/10',
  neutral: 'border-border bg-muted',
};
